import { fHumanReadableCurrency, toNumber } from '@aibees/shared/utils';
import { CompanyAnnualRevenueProps } from './types';

export function useCompanyAnnualRevenue(
  value: CompanyAnnualRevenueProps['value']
) {
  if (!value) return '-';
  const [start, end] = value.split('-').map(toNumber);
  if (start && start >= 10000000000) return '$10B+';
  return [
    fHumanReadableCurrency(start, 0),
    fHumanReadableCurrency(end, 0),
  ].join(' - ');
}
